module.exports = __webpack_public_path__ + "static/media/trilogy.1c398723.png";